import Lottie from "lottie-react";
import { Suspense, useEffect, useState } from "react";
import DASH_IS_LOADING from "./assets/Dash-is-Loading.json";

export enum LottieAnimationType {
  ONBOARDING_CHECK = "dash-onboarding-check",
  HIGH_FIVE = "high-five",
  DASH_IS_LOADING = "dash-is-loading",
  PIN_BROWSER_EXTENSION = "pin-browser-extension",
}

type LottieAnimationProps = {
  animationType?: LottieAnimationType;
  autoplay?: boolean;
  loop?: boolean;
  className?: string;
  alt?: string;
  onLoad?: () => void;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
function normalizeAnimationImport(animationData: any): object {
  return animationData.default || animationData;
}

export const LottieAnimation = ({
  animationType,
  autoplay,
  loop,
  className,
  alt,
  onLoad,
}: LottieAnimationProps) => {
  const [isLoaded, setIsLoaded] = useState(false);
  const [animationData, setAnimationData] = useState({});

  useEffect(() => {
    (async () => {
      let animationData;

      /**
       * We can't pass in a variable to the URL otherwise an error is through about critical dependencies on the import
       * So this is the best way I could tell to dynamically import.
       * Pretty unhappy with this, but for now it works.
       */
      switch (animationType) {
        case LottieAnimationType.ONBOARDING_CHECK:
          animationData = await import("./assets/Dash-Onboarding-Check.json");
          break;
        case LottieAnimationType.HIGH_FIVE:
          animationData = await import("./assets/HighFive.json");
          break;
        case LottieAnimationType.PIN_BROWSER_EXTENSION:
          animationData = await import("./assets/Pin-Browser-Extension.json");
          break;
        case LottieAnimationType.DASH_IS_LOADING:
          // Importing dash_is_loading statically since its used in the extension right on popup open. If we dynamically import it it takes longer to load than the popup page.
          animationData = DASH_IS_LOADING;
          break;
        default:
          break;
      }
      animationData = normalizeAnimationImport(animationData);

      if (animationData) {
        if (onLoad) {
          onLoad();
        }
        setAnimationData(animationData);
        setIsLoaded(true);
      }
    })();
  }, [animationType]);

  if (!isLoaded) {
    return null;
  }

  return (
    <Suspense fallback={null}>
      <Lottie
        alt={alt}
        animationData={animationData}
        autoplay={autoplay}
        loop={loop}
        className={className}
      />
    </Suspense>
  );
};
